import React, { useEffect } from "react";
import { games, GameStatus } from "../../config/games";

interface Props {
  onClose: () => void;
  onLaunchGame: (game: string) => void;
}

const STATUS_LABEL: Record<GameStatus, string> = {
  running: "[ ok ]",
  wip: "[ wip ]",
  down: "[ down ]",
};

const GameLauncher: React.FC<Props> = ({ onClose, onLaunchGame }) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black/95 flex items-center justify-center z-50 p-4">
      <div className="w-full max-w-[560px] border border-white/30 bg-black font-mono text-sm">
        {/* title bar */}
        <div className="flex items-center justify-between border-b border-white/30 px-3 py-2">
          <span className="text-white/70">~/arcade</span>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-white/50 hover:text-white transition-colors px-2"
          >
            [x]
          </button>
        </div>

        <div className="p-4">
          <div className="mb-3">
            <span className="text-white/40">$ </span>
            <span className="text-white">ls -l</span>
          </div>

          <div className="space-y-1">
            {games.map((game) => {
              const disabled = game.status === "down";
              return (
                <button
                  key={game.id}
                  onClick={() => !disabled && onLaunchGame(game.id)}
                  disabled={disabled}
                  className={`w-full flex items-baseline gap-3 px-2 py-1.5 text-left border border-transparent transition-colors ${
                    disabled
                      ? "text-white/25 cursor-not-allowed"
                      : "text-white/80 hover:border-white/40 hover:bg-white/5 hover:text-white"
                  }`}
                >
                  <span className="shrink-0">./{game.id}</span>
                  <span className="text-white/30 shrink-0 hidden sm:inline">
                    {game.version}
                  </span>
                  <span className="flex-1 truncate text-white/40 hidden sm:inline">
                    {game.description.toLowerCase()}
                  </span>
                  <span
                    className={`shrink-0 ${
                      disabled ? "text-white/25" : "text-white/50"
                    }`}
                  >
                    {STATUS_LABEL[game.status]}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="mt-4 pt-3 border-t border-white/10 text-white/30 text-xs">
            click to run · esc to quit
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameLauncher;
